import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, tap } from 'rxjs';

import { Location } from '../models/location.model';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class LocationService {
  private apiUrl = environment.apiUrl + '/Location';

  http = inject(HttpClient);

  private locationsCache: Location[] = null;
  private locationsSubject = new BehaviorSubject<Location[]>(null);

  getLocationObservable(): Observable<Location[]> {
    return this.locationsSubject.asObservable();
  }

  getLocations(): Observable<Location[]> {
    if (!this.locationsCache) {
      this.http
        .get<Location[]>(`${this.apiUrl}/GetAllLocations`).pipe(
          tap((locations) => {
          this.locationsCache = locations;
          this.locationsSubject.next(locations);
        })).subscribe();
    }
    return this.getLocationObservable();
  }
}
